module.exports = __webpack_public_path__ + "static/media/affiliatetheme.c8011c9d.svg";